import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { MobileSecurityCompanyGridDataProvider } from '../dataProvider/MobileSecurityCompanyGridDataProvider';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class MobileSecurityCompanyGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MobileSecurityCompanyGridDataProvider);
  }
}
